<template>
  <div class="bg-gray-50 flex items-center justify-center p-6">
    <div class="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 text-center">
      <div v-if="loading">
        <div class="animate-spin inline-block w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full mb-4"></div>
        <h2 class="text-xl font-bold text-gray-900">正在處理您的請求...</h2>
        <p class="text-gray-500 mt-2">請稍候，我們正在更新您的預約狀態。</p>
      </div>

      <div v-else-if="success">
        <div class="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 class="text-2xl font-black text-gray-900 mb-2">處理成功！</h2>
        <p class="text-gray-600 mb-8">{{ message }}</p>
        <!-- <button @click="goHome" class="w-full py-3 bg-gray-900 text-white rounded-xl font-bold">返回首頁</button> -->
      </div>

      <div v-else>
        <div class="w-20 h-20 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2 class="text-2xl font-black text-gray-900 mb-2">處理失敗</h2>
        <p class="text-red-500 mb-8">{{ errorMsg }}</p>
        <!-- <button @click="goHome" class="w-full py-3 bg-blue-600 text-white rounded-xl font-bold">重新嘗試或聯絡客服</button> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '../services/api' // axios instance

import { logger } from '@myorg/type-lib';

const route = useRoute();
const router = useRouter();

const loading = ref(true);
const success = ref(false);
const message = ref('');
const errorMsg = ref('');

// const goHome = () => router.push('/');

onMounted(async () => {
  // 1. 從網址取得 Token (?t=...)
  const token = route.query.t as string;
  logger.log("token",token)

  if (!token) {
    loading.value = false;
    errorMsg.value = '無效的連結參數';
    return;
  }

  try {
    // 2. 發送 POST 到後端 API
    // 注意：後端 API 路徑請根據你的實作調整
    const res = await api().post('/api/booking/public/merchants/booking_confirm', 
      { token: token },
      { _skipGlobalError: true } as any // 標記不要執行全域跳轉
    );

    // 3. 處理成功
    success.value = true;
    message.value = res.data.message || '您的預約狀態已更新。';
  } catch (err: any) {
    loading.value = false; // 確保 loading 關閉
    success.value = false;

    // 取得後端回傳的具體錯誤訊息（例如：此預約已確認過）
    if (err.response && err.response.data) {
      errorMsg.value = err.response.data.error || err.response.data.message || '連結已失效';
    } else {
      errorMsg.value = '網路連線異常，請稍後再試';
    }
    
    // 強制停止其他可能的跳轉
    err._handled = true;
  } finally {
    loading.value = false;
  }
});
</script>